export default {
  title: 'Google Business',
  sections: {
    google_business_info: 'Informacje o Google Business',
    google_reviews: 'Opinie Google',
    settings: 'Ustawienia',
    danger_zone: 'Strefa niebezpieczna',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'Automatyczne odpowiedzi AI',
    },
    reviews_autopilot_daily_limit: {
      label: 'Dzienny limit auto-odpowiedzi AI (min 1, maks. 15)',
    },
    reviews_autopilot_delay_hours: {
      label: 'Liczba godzin po napisaniu opinii',
    },
    unanswered_checkbox: {
      show_all_reviews: 'Pokaż wszystkie opinie',
      show_only_unanswered: 'Tylko bez odpowiedzi',
    },
    rating_filter: {
      label: 'Filtr ocen',
      stars_one: '{{count}} gwiazdka',
      stars_few: '{{count}} gwiazdki',
      stars_many: '{{count}} gwiazdek',
      stars_other: '{{count}} gwiazdki',
    },
    sorting: {
      newest_to_oldest: 'Sortuj od najnowszych',
      oldest_to_newest: 'Sortuj od najstarszych',
      rating_highest_to_lowest: 'Sortuj od najwyższej oceny',
      rating_lowest_to_highest: 'Sortuj od najniższej oceny',
    },
  },
  table: {
    pagination: {
      total_one: 'Łącznie {{count}} opinia',
      total_few: 'Łącznie {{count}} opinie',
      total_many: 'Łącznie {{count}} opinii',
      total_other: 'Łącznie {{count}} opinii',
    },
  },
  modal_publish: {
    title: 'Czy na pewno chcesz opublikować w Google?',
    buttons: {
      yes: 'Tak',
      cancel: 'Anuluj',
    },
  },
  popconfirm: {
    title: 'Czy na pewno?',
    description: 'Wszystkie lokalne zmiany zostaną nadpisane',
  },
  disconnect_profile: {
    title: 'Odłącz profil',
    button: 'Kontynuuj',
    popconfirm: {
      title: 'Czy na pewno?',
      description:
        'Spowoduje to całkowite odłączenie tego profilu Google od systemu FoodAmigos, wraz z automatycznym zastępowaniem linków i autopilotem odpowiedzi na opinie!',
    },
  },
  buttons: {
    login_with_google: 'Zaloguj przez Google',
    sync_from_google: 'Pobierz aktualną wersję',
    publish_to_google: 'Opublikuj w Google',
    previous: 'Poprzedni',
    next: 'Następny',
    save_settings: 'Zapisz ustawienia',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    failed_to_fetch_reviews: 'Nie udało się pobrać opinii',
    failed_to_fetch_settings: 'Nie udało się pobrać ustawień',
    failed_to_load_google_business: 'Nie udało się załadować Google Business',
    failed_to_publish_to_google_business: 'Nie udało się opublikować w Google Business',
    publish_access_denied:
      'Google odrzucił aktualizację: połączone konto Google nie może już edytować tego Profilu Firmy. Sprawdź jego dostęp w Profilu Firmy w Google lub połącz ponownie konto, które zarządza restauracją.',
    failed_to_fetch_info: 'Nie udało się pobrać aktualnej wersji Google Business',
    success_publish_to_google_business: 'Pomyślnie opublikowano w Google Business',
    success_sync_from_google: 'Pomyślnie zsynchronizowano z Google Business',
    success_save_settings: 'Ustawienia zostały zapisane',
    failed_to_disconnect_profile: 'Nie udało się odłączyć Google Business, skontaktuj się z zespołem technicznym!',
    popup_blocked: 'Zezwól na wyskakujące okienka dla tej strony, aby połączyć Google Business.',
    failed_to_connect: 'Nie udało się połączyć Google Business. Spróbuj ponownie.',
    no_business_profile:
      'To konto Google nie zarządza żadnym Profilem Firmy. Zaloguj się na konto Google, które zarządza restauracją.',
  },
  callback: {
    connecting: 'Łączenie z Google Business…',
    connected: 'Google Business jest połączony. To okno można zamknąć.',
    cancelled: 'Logowanie zostało anulowane. To okno można zamknąć.',
    failed: 'Nie udało się połączyć Google Business. Zamknij to okno i spróbuj ponownie.',
  },
  alerts: {
    no_profile: {
      title: 'Brak połączonego miejsca Google',
      description: 'Połącz restaurację z miejscem Google.',
      button: {
        connect: 'Połącz',
      },
    },
    unverified_location: {
      title: 'Google Business nie jest zweryfikowany',
      description: 'Zweryfikuj swój Google Business, aby kontynuować',
    },
  },
};
